import { useQuery } from "@tanstack/react-query";
import {
  sanityClient,
  faqsPageQuery,
  type FaqCategoryWithItems,
} from "../sanity";

export function useFaqs() {
  return useQuery({
    queryKey: ["faqs"],
    queryFn: () =>
      sanityClient.fetch<FaqCategoryWithItems[]>(faqsPageQuery),
    staleTime: 1000 * 60 * 5,
  });
}
